import { render, staticRenderFns } from "./policiesSold.vue?vue&type=template&id=2e6b8c8b&scoped=true&"
import script from "./policiesSold.vue?vue&type=script&lang=js&"
export * from "./policiesSold.vue?vue&type=script&lang=js&"
import style0 from "./policiesSold.vue?vue&type=style&index=0&id=2e6b8c8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b8c8b",
  null
  
)

export default component.exports